export default __webpack_public_path__ + "static/media/Group1268-yono@2x.23d1f9a9.png";